module.exports = __webpack_public_path__ + "7bf8ac139a52f8176f365d5504ca1797.svg";